"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandleHttpErrorException = void 0;
const axios_1 = require("axios");
const errors_1 = require("../errors");
function HandleHttpErrorException() {
    function generateGenericUnknownError(error) {
        return new errors_1.UserPreferenceClientError(error.message, 'unknown_error', "That's weird, we found an unexpected error, if this " +
            'continues please contact to User preference teams', error);
    }
    function detectUserPreferenceError(error) {
        var _a, _b, _c, _d, _e, _f;
        const responseData = error.response.data;
        const errorCode = (_b = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code;
        const errorMessage = (_d = (_c = responseData === null || responseData === void 0 ? void 0 : responseData.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.message;
        const errorDetail = (_f = (_e = responseData === null || responseData === void 0 ? void 0 : responseData.errors) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.details;
        if (!errorMessage || !errorDetail) {
            return generateGenericUnknownError(error);
        }
        else {
            switch (error.response.status) {
                case 400:
                    return new errors_1.InvalidParamsError(errorMessage, errorCode, errorDetail, error);
                case 401:
                    return new errors_1.UnauthorizedError(errorMessage, errorCode, errorDetail, error);
                case 404:
                    return new errors_1.NotFoundError(errorMessage, errorCode, errorDetail, error);
                case 500:
                    return new errors_1.ServerError(errorMessage, errorCode, errorDetail, error);
                default:
                    return new errors_1.UserPreferenceClientError(errorMessage, errorCode, errorDetail, error);
            }
        }
    }
    function detectHttpError(error) {
        if (error.response) {
            return detectUserPreferenceError(error);
        }
        else if (error.request) {
            return new errors_1.UserPreferenceClientError('Unable to receive a response from User preferences service', 'no_response', 'The request was made but no response was received, ' +
                'this could be due to connection problems or issues on User preferences service', error);
        }
    }
    return (target, propertyKey, descriptor) => {
        const methodImplementation = descriptor.value;
        descriptor.value = function (...args) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    return yield methodImplementation.apply(this, args);
                }
                catch (error) {
                    if (axios_1.default.isAxiosError(error)) {
                        throw detectHttpError(error);
                    }
                    else {
                        throw generateGenericUnknownError(error);
                    }
                }
            });
        };
        return descriptor;
    };
}
exports.HandleHttpErrorException = HandleHttpErrorException;
//# sourceMappingURL=http-error-exception.decorator.js.map